// extracted by mini-css-extract-plugin
export default {"detailCustomerSection":"customer_detailCustomerSection__dPJEU","mainHeading":"customer_mainHeading__tPK5W","cardCustomerDetails":"customer_cardCustomerDetails__ord1c"};